import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import { CustomerContact } from "../../shared/models/customerContactsModels";
import { CustomerShippingOptions } from "../../shared/models/customerShippingModels";
import { CompaniesQuery, CustomerCompany, CustomerCompanyDetails } from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
}

class CustomerCompaniesApi {
  getCompanies(query: CompaniesQuery): Promise<Page<CustomerCompany>> {
    return api.get<Page<CustomerCompany>>(
      `/v1/public/customers`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } }).then(x => x.data);
  }

  getCompany(id: string): Promise<CustomerCompanyDetails> {
    return api.get<CustomerCompanyDetails>(`/v1/public/customers/${id}`, getRequestConfig()).then(x => x.data);
  }

  getCompanyContacts(id: string): Promise<CustomerContact[]> {
    return api.get<CustomerContact[]>(`/v1/public/customers/${id}/contacts`, getRequestConfig()).then(x => x.data);
  }

  getShippingOptions(id: string): Promise<CustomerShippingOptions> {
    return api.get<CustomerShippingOptions>(`/v1/public/customers/${id}/shipping-options`, getRequestConfig()).then(x => x.data);
  }
}

export default new CustomerCompaniesApi();